import * as React        from "react";
import {cx}              from "emotion";
import {faMessage,
        faRotateRight,
        faPen,
        faImagePortrait} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import "./ai-tool-option.scss";

import {ComponentLink,
        Link,
        makeChain}     from "@Common/react/cst2";


export const AiToolOption = ({
    name,
    active,
    inactiveMessage  = null,
    onSelect
}:{
    name             : string,
    active           : boolean,
    inactiveMessage ?: string,
    onSelect         : () => Promise<void>,
}) => (

    makeChain<JSX.Element>()

    .then("displayText", ({}, next:Link<JSX.Element, any>) => next({
        expand: "Expand Text",
        summarize: "Summarize Text",
        reword: "Reword Text",
        generate: "Generate New Text",
        image: "Generate Text from Image",
    }))

    .then("icons", ({}, next:Link<JSX.Element, any>) => next({
        expand: faMessage,
        summarize: faMessage,
        reword: faRotateRight,
        generate: faPen,
        image: faImagePortrait
    }))

    .then(({displayText, icons}) => (
        <div className={cx("ai-tool-option-g7d", {inactive: !active})}
            xd-qa-type="button" xd-qa-name={"Text Gen Tools Drop Down AI Option "+name}
            onClick={active ? onSelect : null}
        >
            <FontAwesomeIcon className="icon" icon={icons[name]}/>
            <p xd-qa-type="dropdown_item" xd-qa-name={displayText[name]} >{displayText[name]}</p>
            {!!inactiveMessage && (
                <div className="inactive-reason">
                    {inactiveMessage}
                </div>
            )}
        </div>
    ))

    .run()

);